<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Account',
  data () {
    return {}
  }
}
</script>
